export class GraphTempModel {
  
  PageNo: number;
  PageSize: number;
  Name:string;
  GraphTemplateTypeId:number;
}
export class CharacteristicsDDLModel {
  CharacteristicId: number;
  Name: string;
}